export function evaluatePassword(pwd = "") {
  const rules = [
    { id: "length",  label: "At least 8 characters",       ok: pwd.length >= 8 },
    { id: "upper",   label: "At least 1 uppercase letter",  ok: /[A-Z]/.test(pwd) },
    { id: "lower",   label: "At least 1 lowercase letter",  ok: /[a-z]/.test(pwd) },      // extra (recommended)
    { id: "number",  label: "At least 1 number",            ok: /\d/.test(pwd) },
    { id: "special", label: "At least 1 special symbol",    ok: /[^A-Za-z0-9]/.test(pwd) },
    { id: "space",   label: "No spaces",                     ok: !/\s/.test(pwd) },        // extra (recommended)
  ];

  const fulfilled = rules.filter(r => r.ok);
  const missing   = rules.filter(r => !r.ok);
  const score     = fulfilled.length;

  return {
    rules, fulfilled, missing,
    score, allOK: missing.length === 0,
  };
}
